export const routes = {
  HOME: '/',
  LOGIN: '/login',
  SELECT_ORGANIZATION: '/select-organization',
  TERMS_CONSENT: '/terms/consent',
  LINE: '/line',
  LINE_CONNECT: '/line/connect',
  LINE_EDIT: '/line/:lineChannelId/edit',
  RICH_MENU: '/settings/rich-menu',
  AUTO_REPLY_MESSAGE: '/settings/auto-reply-message',
  RICH_MESSAGE: '/settings/rich-message',
  CARD_TYPE_MESSAGE: '/settings/card-type-message',
  USERS: '/users',
  USERS_EDIT: '/users/:userLineId/edit',
  BAN_STATUS: '/ban-status',
  ORGANIZATION_MANAGEMENT: '/organization-management',
  ORGANIZATION_MANAGEMENT_CREATE: '/organization-management/new',
  ORGANIZATION_MANAGEMENT_EDIT: '/organization-management/:organizationId/edit',
  ACCOUNT_MANAGEMENT: '/account-management',
  ACCOUNT_MANAGEMENT_CREATE: '/account-management/new',
  ACCOUNT_MANAGEMENT_EDIT: '/account-management/:accountId/edit',
  TERMS_MANAGEMENT: '/terms-management',
  TERMS_MANAGEMENT_CREATE: '/terms-management/new',
  TERMS_MANAGEMENT_DETAIL: '/terms-management/:versionId',
  CHAT: '/chat',
  INQUIRY_CHAT: '/inquiry-chat',
  AI_KNOWLEDGE: '/settings/ai-knowledge',
  SEND_MESSAGE_FOR_ALL: '/send-message-for-all',
  DRAFTS: '/send-message-for-all/drafts',
  RESERVATIONS: '/send-message-for-all/reservations',
  SCENARIOS: '/scenarios',
  SCENARIOS_NEW: '/scenarios/new',
  SCENARIO_EDIT: '/scenarios/:scenarioId/edit',
  SCENARIO_STATS: '/scenarios/:scenarioId/stats',
  SCENARIO_PREVIEW: '/scenarios/:scenarioId/preview',
  SUMMARY_MANAGEMENT: '/summary-management',
  FRIEND_ANALYTICS: '/friend-analytics',
  MESSAGE_SETTINGS: '/message-settings',
  OA_CREATION: '/oa-creation',
  AD_CODES: '/ad-codes',
  AD_CODES_CREATE: '/ad-codes/new',
  AD_CODES_DETAIL: '/ad-codes/:adCodeId',
  AD_CODES_EDIT: '/ad-codes/:adCodeId/edit',
  TAG_MANAGEMENT: '/tag-management',
  TAG_MANAGEMENT_CREATE: '/tag-management/new',
  TAG_MANAGEMENT_EDIT: '/tag-management/:tagId/edit',
  SURVEY_MANAGEMENT: '/survey-management',
  SURVEY_MANAGEMENT_CREATE: '/survey-management/new',
  SURVEY_MANAGEMENT_EDIT: '/survey-management/:surveyId/edit',
  SURVEY_MANAGEMENT_AGGREGATION: '/survey-management/:surveyId/aggregation',
} as const;

export const ORGANIZATION_SCOPE_PREFIX = '/o';
export const ORGANIZATION_SCOPE_PARAM = ':orgId';
export const ORGANIZATION_SCOPE_ROOT = `${ORGANIZATION_SCOPE_PREFIX}/${ORGANIZATION_SCOPE_PARAM}`;

export function orgPath(
  organizationId: number | string,
  route: string,
): string {
  return `${ORGANIZATION_SCOPE_PREFIX}/${organizationId}${route}`;
}

export function orgRoutePath(route: string): string {
  return `${ORGANIZATION_SCOPE_ROOT}${route}`;
}

/** '/o/123/chat' → '/chat'。組織スコープ外の場合はそのまま返す。 */
export function stripOrganizationScopePrefix(pathname: string): string {
  const match = /^\/o\/\d+(\/.*)?$/.exec(pathname);
  if (!match) return pathname;
  return match[1] ?? '/';
}

/** チャット画面（チャット・お問い合わせチャット）か。組織スコープの有無は問わない。 */
export function isChatRoutePath(pathname: string): boolean {
  const path = stripOrganizationScopePrefix(pathname);
  return path.startsWith(routes.CHAT) || path.startsWith(routes.INQUIRY_CHAT);
}

// backend の組織 ID（INT 列）の上限。超えた値は backend が 400 で拒否する
const MAX_ORGANIZATION_ID = 2147483647;

export function parseOrganizationIdParam(
  value: string | undefined,
): number | null {
  if (!value || !/^[1-9][0-9]*$/.test(value)) return null;
  const parsed = Number(value);
  return parsed <= MAX_ORGANIZATION_ID ? parsed : null;
}
